export { default } from './product-quick-view-drawer';
